import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

const ResizableSortableTableHeader = ({ 
  columnKey, 
  label, 
  width, 
  sortConfig, 
  onSort, 
  onResize,
  className = "text-left",
  sortable = true 
}) => {
  const handleMouseDown = (e) => {
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = width;
    
    const onMouseMove = (e) => {
      const newWidth = startWidth + (e.clientX - startX);
      onResize(columnKey, newWidth);
    };
    
    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
    
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return (
    <th 
      className={`px-4 py-3 text-xs font-bold text-slate-600 uppercase relative ${
        sortable ? 'cursor-pointer hover:bg-slate-100 transition-colors group' : ''
      } ${className}`}
      style={{ width: `${width}px` }}
      onClick={sortable ? () => onSort(columnKey) : undefined}
    >
      <div className="flex items-center gap-1">
        {label}
        {sortable && (
          <>
            {sortConfig.key === columnKey ? (
              sortConfig.direction === 'asc' ? <ArrowUp size={14} /> : <ArrowDown size={14} />
            ) : (
              <ArrowUpDown size={14} className="opacity-0 group-hover:opacity-50" />
            )}
          </>
        )}
      </div>
      <div 
        className="absolute right-0 top-0 bottom-0 w-1 cursor-col-resize hover:bg-blue-500 z-10"
        onMouseDown={handleMouseDown}
      />
    </th>
  );
};

export default ResizableSortableTableHeader;
